import { PersonalInformationFieldNames } from 'features/new-actor/enums/personalInformationFieldNames';
import * as Yup from 'yup';
import { ValidationRules } from 'helpers/createFormConfig';

export const personalInformationValidationRules: ValidationRules<PersonalInformationFieldNames> =
{
  [PersonalInformationFieldNames.Civility]: Yup.string().required(
    'Ce champ est requis'
  ),

  [PersonalInformationFieldNames.FirstName]: Yup.string()
    .trim()
    .required('Ce champ est requis')
    .min(2, 'Ce champ doit contenir au moins 2 caractères')
    .max(50, 'Ce champ ne doit pas dépasser 50 caractères'),

  [PersonalInformationFieldNames.LastName]: Yup.string()
    .trim()
    .required('Ce champ est requis')
    .min(2, 'Ce champ doit contenir au moins 2 caractères')
    .max(50, 'Ce champ ne doit pas dépasser 50 caractères'),

  [PersonalInformationFieldNames.BirthName]: Yup.string()
    .trim()
    .nullable()
    .max(50, 'Ce champ ne doit pas dépasser 50 caractères'),

  [PersonalInformationFieldNames.BirthDate]: Yup.date()
    .required('Ce champ est requis')
    .max(new Date(), 'La date de naissance ne peut pas être dans le futur')
    .typeError('Date invalide'),

  [PersonalInformationFieldNames.Nationality]: Yup.string().required(
    'Ce champ est requis'
  ),

  [PersonalInformationFieldNames.BirthCountry]: Yup.string().required(
    'Ce champ est requis'
  ),

  [PersonalInformationFieldNames.Phone]: Yup.string()
    .matches(/^(\+33|0)[1-9](\d{2}){4}$/, 'Numéro de téléphone invalide')
    .required('Ce champ est requis'),

  [PersonalInformationFieldNames.Email]: Yup.string()
    .email("L'adresse email n'est pas valide")
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      'L\'email doit avoir un domaine valide avec une extension'
    )
    .required('Ce champ est requis'),

  [PersonalInformationFieldNames.TaxResidenceCountryId]: Yup.string()
    .trim()
    .required('Le pays de résidence fiscale est requis')
    .matches(/^[A-Z]{2}$/, 'Le pays doit être un code ISO à 2 lettres'),

  [PersonalInformationFieldNames.IsPPE]: Yup.boolean()
    .required('Ce champ est requis')
    .oneOf([true, false], 'Valeur invalide'),

  [PersonalInformationFieldNames.TaxResidenceCountryId]: Yup.string()
    .trim()
    .required('Le pays de résidence fiscale est requis')
    .matches(/^[A-Z]{2}$/, 'Le pays doit être un code ISO à 2 lettres'),

  [PersonalInformationFieldNames.IsFPE]: Yup.boolean()
    .required('Ce champ est requis')
    .oneOf([true, false], 'Valeur invalide')
};
